// servicesData.js
const services = [
    {
      icon: "🧾",
      title: "Audit Financier",
      details:  [
        "Audits statutaires",
        "Due diligence",
        "Reporting consolidé / groupe"
      ],
      detailData: {
        title: "Audit Financier",
        subtitle: "Focus sur l'offre / l'équipe / les compétences / les certifications ",
        sections: [
          { title: "OFFRE", image: "/images/offre.png", points: ["Participation aux audits juridiques et contractuels",
           "Intégration dans les équipes d'audit à distance, participation aux activités d'audit",
            "Planification",
            "Examens intermédiaires",
            "Examens limités",
            "Validation de la diligence",
            "Supervision",
            "Clôture et finalisation des évaluations",
            "Soutenir l'équipe ou travailler directement avec les clients",
            "Possibilité d'utiliser une adresse électronique dédiée"] },
          { title: "ÉQUIPE",image:"/images/equipe.png", points: ["Mise à disposition d'auditeurs financiers hautement qualifiés ",
          "Experts Comptables",
          "Certifiés - IFRS",
          "Trilingue",
          "Tous les niveaux d'ancienneté (de junior à très expérimenté)"] },
          { title: "COMPÉTNCES",image:"/images/competence.png", points: [
            " Couvrir les secteurs économiques les plus importants",
            "Industrie financière",
            "Industrie",
            "Grande distribution",
            "Et différents types de missions",
            "États financiers consolidés et audit des rapports de groupe ",
            "Audit organisationnel",
            "Audit des projets "
          ] },
          { title: "CERTIFICATIONS",image:"/images/certificate.png", points: [
            "Expert Comptable",
            "Diplôme en comptabilité, contrôle et audit (CCA Master)",
            "Certification IFRS",
            "PMP",
            "FRM",
            "CISA" ,
            "Certification GRI",
            "COBIT",
            "ITIL",
          
          ] }
        ]
      }
    },
    {
      icon: "🖥️",
      title: "Audit IT",
      details: [
        "Contrôles généraux IT (ITGC)",
        "Rapports SOC 1 / SOC 2",
        "Cyber sécurité et conformité réglementaire"
      ],
      detailData: {
        title: "Audit IT",
        subtitle: "Focus sur l'offre / l'équipe / les compétences / les certifications ",
        sections: [
          { title: "OFFRE", image: "/images/offre.png", points: ["Procédures spécifiques au client",
            "ITGC",
            "ACTI",
            "Évaluation du rapport SO" ,           
            "Assurance par un tiers",
            "SOC 1 (contrôle interne)",
            "SOC 2 (Sécurité)",
            "SOC opérationnel"] },
          { title: "ÉQUIPE",image:"/images/equipe.png", points: ["Membres de l’équipe avec une expérience spécifique dans les domaines suivants", 
            "Technologies de l'information",
            "Finances" ,
            "Cybersécurité",
            "Tous les niveaux d'ancienneté (de junior à très expérimenté)"] },
          { title: "COMPÉTNCES",image:"/images/competence.png", points: ["Contrôle des technologies de l'information",
          "Contrôles automatisés" ,"Assurance des tiers" ] },
          { title: "CERTIFICATIONS",image:"/images/certificate.png", points: ["Accréditation de spécialiste en informatique",
            "Fondation ITIL V4",
            "COBIT",
            "CISA",
            "ISO 27001 LL/LA",
            "Certification Hacker éthique"] }
        ]
      }
    },
    {
      icon: "🛠️",
      title: "Comptabilité & Support Opérationnel",
      details: [
        "Facturation",
        "Contrôle de gestion",
        "Paie",
        "Reporting financier"
      ],
      detailData: {
        title: "Comptabilité & Support Opérationnel",
        subtitle: "Focus sur l'offre / l'équipe / les compétences / les certifications ",
        sections: [
          { title: "OFFRE", image: "/images/offre.png", points: [
            
            "Assistance en matière de facturation, de contrôle, de comptes comptables",
            "Assistance à la mise à jour de la base de données RH",
            "Soutenir la clôture financière périodique (mensuelle, annuelle, autre)",
            "Effectuer des contrôles pour garantir l'intégrité des données financières",
            "Préparation de rapports exécutifs",
"            Gestion des processus de contrôle financier, y compris l’examen et l’analyse des chiffres trimestriels et des informations financières"  ,         
"Fournir aux parties prenantes des informations financières précises et complètes"
          ] },
          { title: "ÉQUIPE",image:"/images/equipe.png", points: [
            "Experts Comptables",
            "Diplômés en finance",
            "Diplômés en comptabilité",
            "Diplômes en gestion",
            "Spécialistes de la gestion de la paie",
            "Trilingue",  
            "Tous les niveaux d'ancienneté (de junior à très expérimenté)",
          ] },
          { title: "COMPÉTNCES",image:"/images/competence.png", points: [
           "Excellentes compétences en Excel et PowerPoint",
            "Outils de reporting tels que planning analytics",
           "Compétences en traitement des données",
            "Compétences en communication",
        ] },
          { title: "CERTIFICATIONS",image:"/images/certificate.png", points: [
            "Expert Comptable",
            "Diplôme en comptabilité, contrôle et audit (CCA Master)",
            "Master en finance et/ou administration",
          ] }
        ]
      }
    },
  ];
  
  export default services;
  